<template>
  <div>
    <JobApplicationForm />
  </div>
</template>

<script>
import JobApplicationForm from "../../components/Forms/JobApplicationForm.vue";

export default {
  name: "Career",
  components: { JobApplicationForm }
};
</script>
